module.exports = __webpack_public_path__ + "static/media/tarjeta_movil.f3181c2b.png";